
import sitecfg from '@/sitecfg.js'

const app = {
  state: {
    lang: sitecfg.default_lang || "en",
    is_tronlink_installed: window.tronWeb ? true : false,
  },
  mutations: {
    lang(state, str) {
      state.lang = str;
    },
    setAppKey(state, obj) {
      for (let key in obj) {
        state[key] = obj[key];
      }
    },
  },
}

export default app